import { createFileRoute } from '@tanstack/react-router';

import { ProfileMail } from '../../../features/webmail/profile-mail.tsx';

export const Route = createFileRoute('/_app/profile/mail')({
  component: ProfileMail,
});
